// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"29":"3d043791","658":"a39a2c5f","772":"6125c6e5","885":"f07dbfdb","936":"f07dbfdb"}[chunkId] + ".chunk.css";
};